document.addEventListener('DOMContentLoaded', function () {
  var marquees = document.querySelectorAll('[data-sector5-marquee]');
  if (!marquees.length) return;

  marquees.forEach(function (marquee) {
    var track = marquee.querySelector('.sector5-bestsellers__track');
    if (!track) return;

    var speed = 0.55; // px per frame auto-advance
    var offset = 0; // current translateX in px, kept within (-halfWidth, 0]
    var halfWidth = 0;
    var paused = false;
    var dragging = false;
    var dragStartX = 0;
    var dragStartOffset = 0;
    var dragMoved = false; // crossed the tap-vs-drag threshold this gesture
    var justDragged = false; // suppress the click that follows a real drag
    var DRAG_THRESHOLD = 6; // px

    function measure() {
      halfWidth = track.scrollWidth / 2;
    }

    function wrapOffset() {
      if (halfWidth <= 0) return;
      while (offset <= -halfWidth) offset += halfWidth;
      while (offset > 0) offset -= halfWidth;
    }

    function render() {
      track.style.transform = 'translateX(' + offset + 'px)';
    }

    function tick() {
      if (!paused && !dragging) {
        offset -= speed;
        wrapOffset();
        render();
      }
      requestAnimationFrame(tick);
    }

    function pause() {
      paused = true;
    }

    function resume() {
      paused = false;
    }

    marquee.addEventListener('mouseenter', pause);
    marquee.addEventListener('mouseleave', resume);
    marquee.addEventListener('focusin', pause);
    marquee.addEventListener('focusout', resume);

    marquee.addEventListener(
      'wheel',
      function (event) {
        var delta = Math.abs(event.deltaY) > Math.abs(event.deltaX) ? event.deltaY : event.deltaX;
        if (delta === 0) return;
        event.preventDefault();
        offset -= delta;
        wrapOffset();
        render();
      },
      { passive: false }
    );

    marquee.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      dragging = true;
      paused = true;
      dragMoved = false;
      dragStartX = event.clientX;
      dragStartOffset = offset;
    });

    marquee.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      var delta = event.clientX - dragStartX;
      if (!dragMoved) {
        if (Math.abs(delta) < DRAG_THRESHOLD) return;
        dragMoved = true;
        if (marquee.setPointerCapture) {
          try {
            marquee.setPointerCapture(event.pointerId);
          } catch (e) {}
        }
      }
      offset = dragStartOffset + delta;
      wrapOffset();
      render();
    });

    function endDrag(event) {
      if (!dragging) return;
      dragging = false;
      paused = false;
      if (dragMoved) {
        justDragged = true;
        if (marquee.releasePointerCapture) {
          try {
            marquee.releasePointerCapture(event.pointerId);
          } catch (e) {}
        }
      }
    }

    marquee.addEventListener('pointerup', endDrag);
    marquee.addEventListener('pointercancel', endDrag);

    marquee.addEventListener(
      'click',
      function (event) {
        if (justDragged) {
          justDragged = false;
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );

    window.addEventListener('resize', measure);
    measure();
    render();
    requestAnimationFrame(tick);
  });
});
